<template>
<div class="itemRow">
	<div v-if="item.type === 'now'" class="now">
		<div class="item1">
			<div class="load_id">
				<div class="text">Currently</div>
			</div>
		</div>
		<div class="item2">
			<div class="infoDate">
				<div class="icon"><svg-sprite icon-id="icLocation" width="20" height="20"></svg-sprite></div>
				<div class="date">{{ getFormatToUS(item.date) }}</div>
			</div>
		</div>
	</div>
	<div v-if="item.city" class="navigationAddressItem" >
		<div class="item1">
			<div class="load_id">
				<div class="text">{{ item.load_id }}</div>
				<div class="icon"><svg-sprite :icon-id="iconType" width="20" height="20"></svg-sprite></div>
			</div>
		</div>
		<div class="item2">
			<div class="infoDate">
				<div class="text" v-if="item.city">{{ item.city }}, {{ item.state }}, {{ item.zip_code }}</div>
				<div class="date">{{ getFormatToUS(item.date) }}</div>
			</div>
		</div>
	</div>

</div>
</template>

<script>
import { formatToUS } from "@/helper/formatToUS";

export default {
	name: "NavigationAddressItem",
	props: {
		item: Object,
	},
	computed: {
		iconType() {
			 return this.item.type === 'delivery' ? 'arrowDropUpLocation' : 'arrowDropDownLocation';
		}
	},
	methods: {
		getFormatToUS(dateTime) {
			return formatToUS(dateTime);
		},
	}
};
</script>

<style scoped lang="scss">
@import "navigationAddressItem";
</style>
